import { createReducer } from '@reduxjs/toolkit';
import { CompletedItem, ToBeProcessedItem } from 'modules/contract-processing/types';
import {
  setContractProcessingLoadingAction,
  setContractProcessingDataAction,
  setContractProcessingErrorAction,
  setBulkConfirmErrorsAction,
  setCompletedDataAction,
  setCompletedErrorAction,
} from 'store/actions/contract-processing-actions';

export interface IContractProcessingState {
  loading: boolean;
  items: ToBeProcessedItem[];
  totalItems: number;
  error: boolean;
  bulkConfirmErrors: Record<number, string>;
  completedItems: CompletedItem[];
  completedTotalItems: number;
  completedError: boolean;
}

const initialState: IContractProcessingState = {
  loading: false,
  items: [],
  totalItems: 0,
  error: false,
  bulkConfirmErrors: {},
  completedItems: [],
  completedTotalItems: 0,
  completedError: false,
};

const contractProcessingReducer = createReducer(initialState, builder => {
  builder
    .addCase(setContractProcessingLoadingAction, (state, action) => ({
      ...state,
      loading: action.payload,
    }))
    .addCase(setContractProcessingDataAction, (state, action) => ({
      ...state,
      items: action.payload.items,
      totalItems: action.payload.totalItems,
    }))
    .addCase(setContractProcessingErrorAction, (state, action) => ({
      ...state,
      error: action.payload,
    }))
    .addCase(setBulkConfirmErrorsAction, (state, action) => ({
      ...state,
      bulkConfirmErrors: action.payload,
    }))
    .addCase(setCompletedDataAction, (state, action) => ({
      ...state,
      completedItems: action.payload.items,
      completedTotalItems: action.payload.totalItems,
    }))
    .addCase(setCompletedErrorAction, (state, action) => ({
      ...state,
      completedError: action.payload,
    }));
});

export default contractProcessingReducer;
